import React, { useState, useEffect, useContext } from "react";
import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";
import {
  FaStar,
  FaRegStar,
  FaRegClock,
  FaHeart,
  FaAlignLeft,
} from "react-icons/fa";
import { Link } from "react-router-dom";

import TherapistSidebar from "../../inc/TherapistSidebar";
import { AuthContext } from "../../../utility/services/AuthContext";
import Functions from "../../../utility/services/Functions";
import ConstConfig from "../../../utility/configs/constConfig";
import ImageConfig from "../../../utility/configs/imageConfig";
import ApiService from "../../../utility/services/ApiService";
import Image from "react-bootstrap/Image";
import NoDataFoundIcon from "../../images/no_result_in_state.gif";
import ReactLoader from "react-js-loader";
import Button from "react-bootstrap/Button";
import { Tooltip } from "react-tooltip";
import FavLoader from "../../common/FavLoader";
import UserAvatar from "../../common/UserAvatar";
import { trackButtonClick, trackEvent } from "../../../utility/services/analyticsService";

const PatientFavourite = () => {
  // LOGICAL_VARIABLES
  const { setLoading, user } = useContext(AuthContext);
  const { consoleService, isLastPage, getStars, simpleArrayString } =
    Functions();
  const { get_favorites_list, add_to_favorite } = ApiService();

  const [filterHideShow, setfilterHideShow] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  const [loadmoreLoading, setLoadmoreLoading] = useState(false);
  const [therapistListPageNo, setTherapistListPageNo] = useState("1");

  // DATA VARIABLES

  const [therapistList, setTherapistList] = useState([]);
  const [totalDocs, setTotalDocs] = useState("");
  const [selected_card, setSeletcedCard] = useState(null);
  const [fav_loading, setFavLoading] = useState(false);

  // USE EFFECTS

  useEffect(() => {
    fetch_initial_details();
  }, []);

  // FUNCTIONS

  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };

  async function fetch_initial_details() {
    setLoading(true);
    try {
      const res = await get_favorites_list(1);

      if (res.status === 1) {
        setTherapistList([...res.data]);
        setInitialLoading(true);
        setLoading(false);
      } else {
        consoleService("Error in fetch_initial_details", res.message);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch_initial_details", err);
    }
  }

  const loadmore_therapist = async () => {
    if (!loadmoreLoading) {
      setLoadmoreLoading(true);
      const pageNo = Number(therapistListPageNo) + 1;
      try {
        const res = await get_favorites_list(pageNo);
        if (res.status === 1) {
          setTherapistList([...therapistList, ...res.data]);
          setTherapistListPageNo(pageNo);
          setTotalDocs(res.data.ext.total);
          setLoadmoreLoading(false);
        } else {
          consoleService("Error in  loadmore_therapist api", res);
        }
      } catch (err) {
        setLoadmoreLoading(false);
        consoleService("Error in  loadmore_therapist api", err);
      }
    }
  };

  const add_to_favorite_fun = async (therapist_id, status) => {
    try {
      setSeletcedCard(therapist_id);
      setFavLoading(true);
      const data = {
        therapist_id,
        status: !status,
      };
      const res = await add_to_favorite(data);
      if (res.status === 1) {
        const newTherapistList = [];
        therapistList.forEach((item) => {
          if (item.therapist_details._id != therapist_id) {
            newTherapistList.push(item);
          }
        });
        setTherapistList([...newTherapistList]);
        setSeletcedCard(null);
        setFavLoading(false);
      }
    } catch (err) {
      consoleService("error in add_to_favorite_fun =", err);
    }
  };

  const getPriceAndPriceTime = (priceArr) => {
    let priceTime = "";
    let price = "";
    priceArr.forEach((item) => {
      if (item.checked && priceTime.length < 1) {
        price = item.price;
        if (item.time_in_min == "30") {
          priceTime = "30 min";
        } else {
          priceTime = "1 hr";
        }
      }
    });
    return { priceTime, price };
  };

  return (
    <>
      <div className="breadHidePhone">
        <BannerSection banner={Banner} name={"Home"} title={"Favorites"} />
      </div>
      <section className="py-5 useraccount bg-light_dash patient_favourate_main_container">
        <div className="container">
          <div className="row">
            <div
              className={`col-xl-3 col-md-4 ${
                filterHideShow ? "leftShow" : "leftHide"
              }`}
            >
              <TherapistSidebar />
            </div>
            <div
              className="col-xl-9 col-md-8 fulltabBox"
              style={{ backgroundColor: "white" }}
            >
              {therapistList.length > 0 ? (
                <>
                  <div className="filterBox">
                    <Link className="filterIcon" onClick={sideBarHide}>
                      <FaAlignLeft />
                    </Link>
                  </div>
                  <div className="row">
                    <Tooltip
                      id="my-tooltip-s"
                      className="tooltip-custom-container"
                    />
                    {therapistList.map((item, index) => {
                      const therapistDetails = item.therapist_details;
                      const { priceTime, price } = getPriceAndPriceTime(
                        therapistDetails.pricing
                      );
                      const therapistId = therapistDetails._id;
                      const isCurrentCardSelected =
                        selected_card == therapistId;
                      const current_item_in_fav_process =
                        isCurrentCardSelected && fav_loading;

                      return (
                        <div key={index} className="col-md-4 col-lg-4">
                          <div className="popukarsection rightside py-3">
                            <div className="carousel_box">
                              <div className="item_box">
                                {therapistDetails.online_status ? (
                                  <span
                                    className="online"
                                    style={{ backgroundColor: "#4CD964" }}
                                  ></span>
                                ) : (
                                  <span
                                    className="online"
                                    style={{ backgroundColor: "#9E9E9E" }}
                                  ></span>
                                )}
                                <div className="item_body item_body-fav">
                                  <Link
                                    to={`/therapistdetailspage/${therapistId}`}
                                    className="posblock"
                                    onClick={() => {
                                      trackEvent("view_therapist_cta", { event_type: "item_click", screen_name: "Favourites", user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "", user_role: user.details?.role, therapist_name: therapistDetails.name });
                                    }}
                                  >
                                    <UserAvatar
                                      profileImage={therapistDetails.profile_img}
                                      firstName={therapistDetails.first_name || therapistDetails.name}
                                      lastName={therapistDetails.last_name}
                                      size="lg"
                                      className="img-fluid"
                                      alt={`${therapistDetails.name} profile`}
                                    />
                                  </Link>
                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                    <h2>
                                      <Link
                                        to={`/therapistdetailspage/${therapistId}`}
                                        onClick={() => {
                                          trackEvent("view_therapist_cta", { event_type: "item_click", screen_name: "Favourites", user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "", user_role: user.details?.role, therapist_name: therapistDetails.name });
                                        }}
                                      >
                                        {therapistDetails.name}
                                      </Link>
                                    </h2>
                                    <div className="star">
                                      {getStars(
                                        <FaStar />,
                                        <FaRegStar />,
                                        parseFloat(
                                          Number(
                                            therapistDetails.ratings
                                          ).toFixed(1)
                                        )
                                      )}
                                      <span className="score">
                                        ({" "}
                                        {parseFloat(
                                          Number(
                                            therapistDetails.ratings
                                          ).toFixed(1)
                                        )}{" "}
                                        )
                                      </span>
                                    </div>
                                  </div>
                                  <p
                                    data-tooltip-id="my-tooltip-s"
                                    data-tooltip-content={
                                      therapistDetails.speciality
                                    }
                                    className="truncated-text tooltip-container mb-1 h-auto"
                                  >
                                    {therapistDetails.speciality.map(
                                      (item, index) => {
                                        return simpleArrayString(
                                          item,
                                          index,
                                          therapistDetails.speciality
                                        );
                                      }
                                    )}
                                  </p>
                                  <div className="pricearea">
                                    <h4>
                                      <FaRegClock /> {priceTime}
                                    </h4>
                                    <span>${price}</span>
                                  </div>

                                  <p
                                    data-tooltip-id="my-tooltip-s"
                                    data-tooltip-content={therapistDetails.bio}
                                    style={{
                                      marginTop: 2,
                                      display: "-webkit-box",
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                      WebkitLineClamp: 2,
                                      textOverflow: "ellipsis",
                                      position: "relative",
                                    }}
                                  >
                                    {therapistDetails.bio}
                                  </p>

                                  <div className="bookgap">
                                    <Link
                                      to={`/therapistdetailspage/${therapistId}`}
                                      className="btn btn-primary"
                                      onClick={() => {
                                        trackButtonClick("view_therapist_cta", { button_name: "Book Now", screen_name: "Favourites", user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "", user_role: user.details?.role, therapist_name: therapistDetails.name });
                                      }}
                                    >
                                      Book Now
                                    </Link>
                                    <div
                                      className="fav_btn cursor-pointer"
                                      as="button"
                                      onClick={() => {
                                        if (fav_loading) return;
                                        add_to_favorite_fun(therapistId, true);
                                      }}
                                    >
                                      {current_item_in_fav_process ? (
                                        <FavLoader />
                                      ) : (
                                        <FaHeart style={{ color: "#ff674f" }} />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {loadmoreLoading && (
                    <ReactLoader
                      type="ping-cube"
                      bgColor={"#4FF2E2"}
                      size={50}
                    />
                  )}

                  {!loadmoreLoading &&
                    !isLastPage(therapistListPageNo, totalDocs, 10) && (
                      <div className="text-center mt-3">
                        <Button
                          className="btn btnNew btn-primary"
                          onClick={() => {
                            loadmore_therapist();
                          }}
                        >
                          Next
                        </Button>
                      </div>
                    )}
                </>
              ) : (
                <>
                  {initialLoading && (
                    <view
                      style={{
                        height: "80vh",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        paddingLeft: 50,
                        paddingRight: 50,
                        position: "relative",
                      }}
                    >
                      {/* <Image
                        src={NoDataFoundIcon}
                        alt="No Data Found"
                        className="img-fluid noFoundImg3 "
                      /> */}
                      <span className="searchgif_txt" style={{ fontSize: 20 }}>
                        No Data Found
                      </span>
                    </view>
                    // <div className="no_datafound">
                    //   <Image
                    //     src={NoDataFoundIcon}
                    //     alt="No Data Found"
                    //     className="img-fluid noFoundImg"
                    //   />
                    // </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PatientFavourite;
